var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.692 3.158C15.896 3.464 16.1 3.77 16.1 4.076C16.1 4.382 15.998 4.688 15.692 4.994L11.918 8.768V19.376C11.918 19.682 11.816 19.988 11.51 20.294C11.204 20.6 11 20.6 10.694 20.6H10.082C9.77599 20.6 9.46999 20.498 9.16399 20.192C8.85799 19.886 8.75599 19.682 8.75599 19.274V14.786H8.14399V19.274C8.14399 19.58 8.04199 19.886 7.73599 20.192C7.42999 20.498 7.22599 20.6 6.81799 20.6H6.20599C5.89999 20.6 5.59399 20.498 5.28799 20.192C4.98199 19.886 4.87999 19.682 4.87999 19.274V8.666L1.20799 4.892C0.901988 4.688 0.799988 4.382 0.799988 4.076C0.799988 3.77 0.901988 3.464 1.20799 3.158C1.51399 2.852 1.71799 2.75 2.12599 2.75C2.53399 2.75 2.73799 2.852 3.04399 3.158L6.40999 6.524H10.49L13.958 3.056C14.264 2.852 14.57 2.648 14.876 2.648C15.182 2.75 15.488 2.852 15.692 3.158ZM5.59399 3.056C5.59399 3.872 5.89999 4.484 6.40999 5.096C6.91999 5.708 7.63399 5.912 8.44999 5.912C9.26599 5.912 9.87799 5.606 10.49 5.096C11.102 4.586 11.306 3.872 11.306 3.056C11.306 2.24 11 1.628 10.49 1.016C9.97999 0.403997 9.26599 0.199997 8.44999 0.199997C7.63399 0.199997 7.02199 0.505997 6.40999 1.016C5.79799 1.526 5.59399 2.24 5.59399 3.056Z",
    fill: "#F68121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmColor);
export default __webpack_public_path__ + "static/media/gm-color.bcff6bd5fc9cab1d607707ea2ed4e4dc.svg";
export { ForwardRef as ReactComponent };